import { useEffect, useState } from 'react';

export function useOpen(defaultValue: boolean = false) {
  const [open, setOpen] = useState(defaultValue);

  useEffect(() => {
    setOpen(!!defaultValue);
  }, [defaultValue]);

  return {
    open,
    setOpen,
  };
}
